import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Head } from '@/components/seo/Head/Head';
import { ForgotUsernameSteps } from '@/features/auth/components/ForgotUsernameSteps/ForgotUsernameSteps';
import { useTranslation } from 'react-i18next';

export const ForgotUsernameRoute = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotUsername' });

  return (
    <>
      <Head title={t('seo.title')} />
      <GenericLayout>
        <ForgotUsernameSteps />
      </GenericLayout>
    </>
  );
};
